<mat-card appearance="outlined" data-cy="patient-appointment-summary-card">
  <mat-card-header data-cy="patient-appointment-summary-header">
    <mat-card-title data-cy="patient-appointment-summary-title">Appointment Summary</mat-card-title>
    <mat-card-subtitle data-cy="patient-appointment-summary-date">Monday May 5 2019 4pm</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content data-cy="patient-appointment-summary-content">
    <mat-list data-cy="patient-appointment-summary-list">
     <mat-list-item data-cy="patient-appointment-summary-item-1">patient-appointment-summary works!</mat-list-item>
     <mat-list-item data-cy="patient-appointment-summary-item-2">Add more information here about the actual procedures</mat-list-item>
     <mat-list-item data-cy="patient-appointment-summary-item-3">list notes</mat-list-item>
    </mat-list>
   </mat-card-content>
    
  <mat-card-actions data-cy="patient-appointment-summary-actions">
    <button mat-button data-cy="patient-appointment-summary-more-button">More ...</button>
  </mat-card-actions>
</mat-card>
